// extracted by mini-css-extract-plugin
module.exports = {"Root":"Alert_Root__MRJzy","Icon":"Alert_Icon__JU3SB"};